import React from 'react';

const BannersSection = () => {
  const banners = [
    { name: 'FORD MULTIMOTORS', image: '/web/Ford.png' },
    { name: 'BIOKEMIA', image: '/web/Biokhemia.png' },
    { name: 'BANCO REPÚBLICA', image: '/web/BROU.png' },
  ];

  return (
    <section className="py-12 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {banners.map((banner, index) => (
            <div
              key={index}
              className="group cursor-pointer transform hover:scale-105 hover:-translate-y-2 transition-all duration-500"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="bg-white rounded-2xl p-6 flex items-center justify-center min-h-[180px] shadow-lg hover:shadow-2xl transition-all duration-300 relative overflow-hidden border border-gray-100">
                <div className="absolute inset-0 bg-gradient-to-br from-green-500/5 to-emerald-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <img
                  src={banner.image}
                  alt={banner.name}
                  className="max-w-full max-h-32 object-contain relative z-10 transform group-hover:scale-110 transition-transform duration-300"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BannersSection;